"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createPromiseQueue;

var _pDeferEs = _interopRequireDefault(require("p-defer-es5"));

function createPromiseQueue() {
  var deferred;
  var queue = [];

  var push = function push(value) {
    if (deferred) {
      var _deferred = deferred,
          resolve = _deferred.resolve;
      deferred = null;
      resolve(value);
    } else {
      queue.push(value);
    }
  };

  var shift = function shift() {
    return queue.length ? Promise.resolve(queue.shift()) : (deferred || (deferred = (0, _pDeferEs["default"])())).promise;
  };

  return {
    push: push,
    shift: shift
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9jcmVhdGVQcm9taXNlUXVldWUuanMiXSwibmFtZXMiOlsiY3JlYXRlUHJvbWlzZVF1ZXVlIiwiZGVmZXJyZWQiLCJxdWV1ZSIsInB1c2giLCJ2YWx1ZSIsInJlc29sdmUiLCJzaGlmdCIsImxlbmd0aCIsIlByb21pc2UiLCJwcm9taXNlIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7QUFFZSxTQUFTQSxrQkFBVCxHQUE4QjtBQUMzQyxNQUFJQyxRQUFKO0FBQ0EsTUFBTUMsS0FBSyxHQUFHLEVBQWQ7O0FBRUEsTUFBTUMsSUFBSSxHQUFHLFNBQVBBLElBQU8sQ0FBQUMsS0FBSyxFQUFJO0FBQ3BCLFFBQUlILFFBQUosRUFBYztBQUNaLHNCQUFvQkEsUUFBcEI7QUFBQSxVQUFRSSxPQUFSLGFBQVFBLE9BQVI7QUFFQUosTUFBQUEsUUFBUSxHQUFHLElBQVg7QUFDQUksTUFBQUEsT0FBTyxDQUFDRCxLQUFELENBQVA7QUFDRCxLQUxELE1BS087QUFDTEYsTUFBQUEsS0FBSyxDQUFDQyxJQUFOLENBQVdDLEtBQVg7QUFDRDtBQUNGLEdBVEQ7O0FBV0EsTUFBTUUsS0FBSyxHQUFHLFNBQVJBLEtBQVE7QUFBQSxXQUNaSixLQUFLLENBQUNLLE1BQU4sR0FBZUMsT0FBTyxDQUFDSCxPQUFSLENBQWdCSCxLQUFLLENBQUNJLEtBQU4sRUFBaEIsQ0FBZixHQUFnRCxDQUFDTCxRQUFRLEtBQUtBLFFBQVEsR0FBRywyQkFBaEIsQ0FBVCxFQUE0Q1EsT0FEaEY7QUFBQSxHQUFkOztBQUdBLFNBQU87QUFDTE4sSUFBQUEsSUFBSSxFQUFKQSxJQURLO0FBRUxHLElBQUFBLEtBQUssRUFBTEE7QUFGSyxHQUFQO0FBSUQiLCJzb3VyY2VSb290IjoiY29yZTovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgY3JlYXRlRGVmZXJyZWQgZnJvbSAncC1kZWZlci1lczUnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBjcmVhdGVQcm9taXNlUXVldWUoKSB7XG4gIGxldCBkZWZlcnJlZDtcbiAgY29uc3QgcXVldWUgPSBbXTtcblxuICBjb25zdCBwdXNoID0gdmFsdWUgPT4ge1xuICAgIGlmIChkZWZlcnJlZCkge1xuICAgICAgY29uc3QgeyByZXNvbHZlIH0gPSBkZWZlcnJlZDtcblxuICAgICAgZGVmZXJyZWQgPSBudWxsO1xuICAgICAgcmVzb2x2ZSh2YWx1ZSk7XG4gICAgfSBlbHNlIHtcbiAgICAgIHF1ZXVlLnB1c2godmFsdWUpO1xuICAgIH1cbiAgfTtcblxuICBjb25zdCBzaGlmdCA9ICgpID0+XG4gICAgcXVldWUubGVuZ3RoID8gUHJvbWlzZS5yZXNvbHZlKHF1ZXVlLnNoaWZ0KCkpIDogKGRlZmVycmVkIHx8IChkZWZlcnJlZCA9IGNyZWF0ZURlZmVycmVkKCkpKS5wcm9taXNlO1xuXG4gIHJldHVybiB7XG4gICAgcHVzaCxcbiAgICBzaGlmdFxuICB9O1xufVxuIl19